import { Outlet, createFileRoute, useLocation, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/lib/auth-context";

// Paths that a limited (non-superadmin) admin may still access.
const LIMITED_ADMIN_ALLOWED = ["/harikaradmin/grant-ticket", "/harikaradmin/points", "/harikaradmin/scan"];

export const Route = createFileRoute("/harikaradmin")({
  component: AdminLayout,
});

function AdminLayout() {
  const { isAdmin, isSuperadmin, loading } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || !isAdmin || isSuperadmin) return;
    // Limited admin: /admin/points is allowed, but reports (/harikaradmin/points-report) are not.
    const allowed = LIMITED_ADMIN_ALLOWED.some(
      (p) => pathname === p || pathname.startsWith(p + "/"),
    );
    if (!allowed) {
      void navigate({ to: "/harikaradmin/grant-ticket", replace: true });
    }
  }, [loading, isAdmin, isSuperadmin, pathname, navigate]);

  return <Outlet />;
}
